import { Typography } from "@mui/material";

export default function TitleText({props,children}){
    return (
        <Typography variant={"h4"} textAlign="center" style={{ color:'#1d385e', fontWeight: 800 }} >
            {children}
        </Typography>
        )
}